import * as React from 'react';
import { useLocation } from 'wouter';
import { CmdLoader } from '@commander-services/gui-components';
import Form from './Form';
import configJs from '../../../config';
import { LanguageContextProps, defaultLanguage } from '../LanguagesContext';

interface IActivateAccountProps {
  context: LanguageContextProps;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const getFormData = (token: string, language: string) => {};

export default function ExpiredPassword(props: IActivateAccountProps): JSX.Element {
  const [, navigate] = useLocation();
  const [form, isForm] = React.useState<any>(null);
  const [token, isToken] = React.useState<string | null>(null);

  React.useEffect(() => {
    const fetchData = async () => {
      const tokenData = window.location.pathname.split('/').pop();
      if (tokenData) {
        isToken(tokenData);
        const data: any = getFormData(tokenData, defaultLanguage);
        if (data) {
          isForm(data.form);
          if (data.language && defaultLanguage !== data.language && props.context.updateValue) {
            props.context.updateValue('language', data.language);
          }
        } else {
          navigate(configJs.Login.homeUrl);
        }
      } else {
        navigate(configJs.Login.homeUrl);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="w-login">
      {form && form.inputs && form.inputs.length > 0 ? (
        <Form data={form.inputs} token={token} />
      ) : (
        <CmdLoader inContent={true} />
      )}
    </div>
  );
}
